import React from 'react';
import { Box, Flex } from '@ghq-abi/design-system';
// eslint-disable-next-line import/no-cycle
import { BaseModal } from '~/shared/components';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose }) => (
  <BaseModal isOpen={isOpen} onClose={onClose}>
    <Flex
      direction="column"
      align="center"
      justify="center"
      css={{
        padding: '$8',
        textAlign: 'center',
        minHeight: '300px',
      }}
    >
      <Box
        css={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#F44336',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '$6',
        }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </Box>
    </Flex>
  </BaseModal>
);
